import { http, URL } from "./http.service";
import { errorHandler } from "./error.service";
import moment from "moment";

export const getSaleDate = async (businessId, fromDate, toDate) => {
  try {
    let resp = await http.get(
      `${URL}/saledate/${businessId}/saleDate/?startDate=${fromDate}&endDate=${toDate}`
    );
    return resp;
  } catch (error) {
    console.log("error in", error);
    return errorHandler(error);
  }
};

export const PandLReportBasicFormat = async (businessId, requiredKeys = []) => {
  try {
    const keysParam = Array.isArray(requiredKeys)
      ? requiredKeys.join(",")
      : requiredKeys;

    const response = await http.get(
      `${URL}/newReportroute/pnl-data/${businessId}`,
      { params: { keys: keysParam } }
    );

    if (!response.data) {
      throw new Error("No data received from API");
    }

    return response;
  } catch (error) {
    console.error("Error fetching report data:", error);
    throw error;
  }
};
export const fetchInventoryData = async (businessId) => {
  try {
    let resp = await http.get(`${URL}/newReportroute/inventory/${businessId} `);
    //  console.log("service resp", resp);
    return resp;
  } catch (error) {
    console.log("error in", error);
    return errorHandler(error);
  }
};

export const PnlBasic = async (businessId, params = {}) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/PnlBasic/${businessId}`,
      {
        params,
      }
    );
    return resp;
  } catch (error) {
    console.log("error in", error);
    return errorHandler(error);
  }
};
export const PnlTrend = async (businessId, params = {}) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/PnlTrend/${businessId}`,
      {
        params,
      }
    );
    return resp;
  } catch (error) {
    console.log("error in", error);
    return errorHandler(error);
  }
};

export const PnlCustomerPending = async (businessId, params = {}) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/CustomerPending/${businessId}`,
      { params }
    );
    return resp;
  } catch (error) {
    console.log("error in getCustomerPendingReport:", error);
    return errorHandler(error);
  }
};

export const getSupplierPending = async (businessId, params = {}) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/SupplierPending/${businessId}`,
      { params }
    );
    return resp;
  } catch (error) {
    console.log("Error in getSupplierPendingReport:", error);
    return errorHandler(error);
  }
};

export const customeSalesReport = async (
  businessId,
  {
    timeRange = "Total Data",
    customFromDate,
    customToDate,
    aggregationType = "none",
    searchSections = [],
  } = {}
) => {
  try {
    const searchSectionsParam = Array.isArray(searchSections)
      ? searchSections.join(",")
      : searchSections;

    const params = {
      timeRange,
      ...(customFromDate && { customFromDate }),
      ...(customToDate && { customToDate }),
      aggregationType,
      ...(searchSections.length > 0 && { searchSections: searchSectionsParam }),
    };

    const resp = await http.get(
      `${URL}/newReportroute/CustomeSalesReport/${businessId}`,
      { params }
    );

    return resp;
  } catch (error) {
    console.error("Error in getSalesReport:", error);
    return errorHandler(error);
  }
};

export const customePurchaseReport = async (
  businessUuid,
  {
    timeRange = "Total Data",
    customFromDate,
    customToDate,
    saleCount = 0,
    status = "",
  } = {}
) => {
  try {
    const params = {
      timeRange,
      ...(customFromDate && {
        customFromDate: moment(customFromDate).format("YYYY-MM-DD"),
      }),
      ...(customToDate && {
        customToDate: moment(customToDate).format("YYYY-MM-DD"),
      }),
      ...(status && { status }),
      // Only include saleCount if it's a valid number > 0
      ...(saleCount !== undefined && saleCount !== "" && !isNaN(saleCount)
        ? { saleCount: Number(saleCount) }
        : {}),
    };

    const resp = await http.get(
      `${URL}/newReportroute/CustomePurchaseReport/${businessUuid}`,
      { params }
    );

    return resp;
  } catch (error) {
    console.error("Error in customePurchaseReport:", error);
    throw error;
  }
};

export const getInventoryReport = async (businessId, params = {}) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/CustomeInventoryReport/${businessId}`,
      { params }
    );
    return resp;
  } catch (error) {
    console.log("Error in getInventoryReport:", error);
    return errorHandler(error);
  }
};

export const getExpenseReport = async (businessId, params = {}) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/CustomeExpenseReport/${businessId}`,
      { params }
    );
    return resp;
  } catch (error) {
    console.log("Error in getExpenseReport:", error);
    return errorHandler(error);
  }
};

export const getCustomerReport = async (businessId, params = {}) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/CustomeCustomerReport/${businessId}`,
      { params }
    );
    return resp;
  } catch (error) {
    console.log("Error in getExpenseReport:", error);
    return errorHandler(error);
  }
};
export const getSupplierReport = async (businessId, params = {}) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/CustomeSupplierReport/${businessId}`,
      { params }
    );
    return resp;
  } catch (error) {
    console.log("Error in getExpenseReport:", error);
    return errorHandler(error);
  }
};

export const getSalesTrendReport = async (businessId, params = {}) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/SaleReport/${businessId}`,
      { params }
    );
    return resp.data;
  } catch (error) {
    console.error("Error in getSalesTrendReport:", error);
    return errorHandler(error);
  }
};

export const getSaleReportByPercent = async (businessId, params = {}) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/SaleReportByPercentage/${businessId}`,
      { params }
    );
    return resp.data;
  } catch (error) {
    console.error("Error in getSaleReportByPercent:", error);
    return errorHandler(error);
  }
};

export const getTrendReport = async (businessId, params = {}) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/SaleReportTrend/${businessId}`,
      { params }
    );
    return resp.data;
  } catch (error) {
    console.error("Error in getTrendReport:", error);
    return errorHandler(error);
  }
};

export const getSalesInvoiceReport = async (businessId, params = {}) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/SaleReportInvoice/${businessId}`,
      { params }
    );

    return resp.data;
  } catch (error) {
    console.error("Error in getSalesInvoiceReport:", error);
    console.error("Error response:", error.response?.data);
    throw error; // Make sure to throw the error
  }
};
export const getReturnTrendReport = async (businessId, params = {}) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/ReturnReportReturnTrend/${businessId}`,
      { params }
    );

    return resp.data;
  } catch (error) {
    console.error("Error in getReturnTrendReport:", error);
    console.error("Error response:", error.response?.data);
    throw error; // Re-throw so the caller can handle it
  }
};

export const getCustomerReportcustomer = async (businessId, params = {}) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/CustomerReport/${businessId}`,
      { params }
    );

    return resp.data;
  } catch (error) {
    console.error("Error in getCustomerReportcustomer:", error);
    console.error("Error response:", error.response?.data);
    throw error; // Re-throw so the caller can handle it
  }
};

export const getReturnByPercentageReport = async (businessId, params = {}) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/ReturnByPercentage/${businessId}`,
      { params }
    );

    return resp.data;
  } catch (error) {
    console.error("Error in getSalesInvoiceReport:", error);
    console.error("Error response:", error.response?.data);
    throw error; // Make sure to throw the error
  }
};
export const getPurchaseDetailedReport = async (businessId, params = {}) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/PurchaseTreand/${businessId}`,
      { params }
    );

    return resp.data;
  } catch (error) {
    console.error("Error in getSalesInvoiceReport:", error);
    console.error("Error response:", error.response?.data);
    throw error; // Make sure to throw the error
  }
};

export const getPurchaseStatusDetailedReport = async (
  businessId,
  params = {}
) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/PurchaseDetailsStatus/${businessId}`,
      { params }
    );

    return resp.data;
  } catch (error) {
    console.error("Error in getSalesInvoiceReport:", error);
    console.error("Error response:", error.response?.data);
    throw error; // Make sure to throw the error
  }
};

export const gstr1report = async (businessId, params = {}) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/GSTR1Report/${businessId}`,
      { params }
    );

    return resp.data;
  } catch (error) {
    console.error("Error in getSalesInvoiceReport:", error);
    console.error("Error response:", error.response?.data);
    throw error; // Make sure to throw the error
  }
};
export const gstr2report = async (businessId, params = {}) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/GSTR2Report/${businessId}`,
      { params }
    );

    return resp.data;
  } catch (error) {
    console.error("Error in getSalesInvoiceReport:", error);
    console.error("Error response:", error.response?.data);
    throw error; // Make sure to throw the error
  }
};

export const getExpenseTrendReport = async (businessId, params = {}) => {
  try {
    const response = await http.get(
      `${URL}/newReportroute/ExpenseTrendReport/${businessId}`,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Error in getExpenseTrendReport:", error);
    return errorHandler(error);
  }
};

export const getRawMaterialDetailedReport = async (
  businessUuid,
  params = {}
) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/getRawMaterialDetailedReport/${businessUuid}`,
      { params }
    );
    return resp;
  } catch (error) {
    console.error("Error in getRawMaterialDetailedReport:", error);
    return errorHandler(error);
  }
};
export const getManufaturingDetailedReport = async (
  businessUuid,
  params = {}
) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/getWarehouseReport/${businessUuid}`,
      { params }
    );
    return resp;
  } catch (error) {
    console.error("Error in getRawMaterialDetailedReport:", error);
    return errorHandler(error);
  }
};



export const getWarehouseStatusCountReport = async (
  businessUuid,
  params = {}
) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/WarehouseStatusCountReport/${businessUuid}`,
      { params }
    );
    return resp;
  } catch (error) {
    console.error("Error in getWarehouseStatusCountReport:", error);
    return errorHandler(error);
  }
};

export const getGSTR3BReport = async (
  businessUuid,
  params = {}
) => {
  try {
    const resp = await http.get(
      `${URL}/newReportroute/GSTR3BReport/${businessUuid}`,
      { params }
    );
    return resp;
  } catch (error) {
    console.error("Error in getGSTR3BReport:", error);
    return errorHandler(error);
  }
};